/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import * as Waves from 'node-waves';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[rippleEffect]',
  standalone: false
})
export class RippleEffectDirective implements OnInit {
  private _nativeElement: any;

  @Input() wave!: string;

  constructor(private _elementRef: ElementRef) {}

  ngOnInit(): void {
    this._nativeElement = this._elementRef.nativeElement;

    if (
      !this._nativeElement.className.split(' ').some((c: string) => {
        return /btn-outline-.*/.test(c);
      }) &&
      !this._nativeElement.className.split(' ').some((c: string) => {
        return /btn-flat-.*/.test(c);
      })
    ) {
      Waves.attach(this._nativeElement, ['waves-float', 'waves-light']);
    } else {
      Waves.attach(this._nativeElement);
    }
  }
}
